import { campaigns, campaignActionType,SAVE_CAMPAIGN } from './types';

export function SaveCampaigns(campaigns: campaigns): campaignActionType {
  return {
    type: SAVE_CAMPAIGN,
    payload: campaigns,
  };
}
